module.exports = __webpack_public_path__ + "img/colour-aubergine.63ed1897.png";